import { useDispatch } from "react-redux";

import type { store } from "./configureStore";

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
